<template>
  <div :class="{'blue-stripe' : entry.complete==true}">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <b-link :to="{name:'dashboard'}">Admin</b-link>
        </li>
        <li class="breadcrumb-item">
          <b-link
            :to="{ name: 'admin-list-entries', params: { uid: uid, name: name   } }"
          >{{name}} ({{uid}})</b-link>
        </li>
        <li
          class="breadcrumb-item active"
          aria-current="page"
        >{{entry.title ? entry.title : '...TBC'}} ({{entry.eid}})</li>
      </ol>
    </nav>
    <div class="container">
      <h5 v-if="entry.complete==true">
        <b-badge variant="primary" class="float-right">Ready for Review</b-badge>
      </h5>
      <!-- PROJECT PERIOD -->
      <div v-if="entry.period">
        <div class="font-italic">Completed {{entry.period}}</div>
      </div>
      <!-- PROJECT TITLE -->
      <div v-if="entry.title">
        <h2 class="display-4">{{entry.title}}</h2>
      </div>
      <div v-if="photoCount > 0">
        <div class="gallery-story">
          <!-- GALLERY -->
          <photo-swipe v-if="photoCount"/>
        </div>
      </div>
      <!-- PROJECT STATEMENT -->
      <div v-if="entry.statement">
        <div class="statement">{{entry.statement}}</div>
      </div>

      <!-- GALLERY -->
      <!-- PHOTOGRAPHS -->
      <div v-if="photoCount > 0">
        <div class="gallery-story">
          <!-- GALLERY -->
          <photo-card v-for="photo in photos" :key="photo.pid" :photo="photo"/>
        </div>
      </div>
    </div>
    <!--.container -->
    <div class="buttons text-right p-3">
      <b-button
        :to="{name:'admin-update-entry', params:{eid: eid, uid: uid, name: name, email: email} } "
        variant="danger"
      >Edit</b-button>

      <b-button
        v-if="entry.complete!==true"
        @click="finaliseEntry()"
        variant="primary"
        class="ml-2"
        :disabled="disabled == 1 ? true : false"
      >Submit</b-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import PhotoCard from '@/components/PhotoCard.vue'
import PhotoSwipe from '@/components/gallery/PhotoSwipe.vue'
// import UpdateGalleryPhoto from '@/components/admin/UpdateGalleryPhoto.vue'
export default {
  name: 'show-entry',
  data() {
    return {
      errors: [],
      disabled: 1
    }
  },
  components: { PhotoCard, PhotoSwipe },
  props: ['eid', 'uid', 'name', 'email'],
  computed: {
    ...mapState({
      entry: state => state.entry.entry,
      user: state => state.user.user,
      // photos: state => state.photo.photos,
      config: state => state.config
    }),
    ...mapGetters({
      photos: 'photo/photoSlides',
      photoCount: 'photo/photoCount'
    }),
    wordCount: () => str => str.trim().split(/\s+/).length,
    containsYear: () => str => str.match(/(194[5-9]|19[5-9]\d|200\d|201[0-9])/),
    notEmptyObject: () => obj =>
      Object.keys(obj).length === 0 && obj.constructor === Object
  },
  methods: {
    validateEntry() {
      //console.log(this.containsYear(this.entry.period))
      if (!this.entry) {
        this.errors.push('no entry')
      }
      if (!this.entry.title) {
        this.errors.push('no title')
      }
      if (!this.entry.period) {
        this.errors.push('no period')
      }
      if (!this.entry.statement) {
        this.errors.push('no statement')
      }

      if (
        this.entry.statement.trim().split(/\s+/).length >
        this.config.statementWordCount
      ) {
        this.errors.push('statement too long')
      }
      if (this.entry.statement.trim().split(/\s+/).length < 20) {
        this.errors.push('statement too short')
      }
      if (!this.photoCount) {
        this.errors.push('No photos')
      }
      if (this.photoCount < this.config.photoCount) {
        this.errors.push('Not enough photos')
      }
      if (!this.errors.length) {
        this.disabled = 0
        return true
      }
      // console.log(this.errors)
    },
    finaliseEntry() {
      if (this.user.complete == false) {
        this.$root.$emit('bv::show::modal', 'modalUser')
      } else {
        if (
          confirm(
            'Once you finalise your entry you will not be able to edit or delete it. Are you sure you want to proceed?'
          )
        ) {
          const updateEntryOb = {
            eid: Number(this.eid),
            uid: this.uid
          }
          this.$store.dispatch('entry/finaliseEntry', updateEntryOb)
          /*
          this.$router.push({
            name: 'list-entries'
          })
          */
        }
      }
    },
    hidden() {
      // console.log('Did complete the form? ' + this.user.complete)
      // console.log('Errors? ' + !this.errors.length)
      if (
        this.user.complete == true &&
        !this.errors.length &&
        !this.entry.complete
      ) {
        const updateEntryOb = {
          eid: Number(this.eid)
        }
        this.$store.dispatch('entry/finaliseEntry', updateEntryOb)
      }
    }
  },
  mounted() {
    const fetchEntryOb = {
      eid: Number(this.eid),
      uid: this.uid
    }
    this.$store.dispatch('entry/fetchEntry', fetchEntryOb)
  },
  updated() {
    this.$nextTick(() => {
      this.validateEntry()

      // console.log('here')
      this.photos.forEach(photo => {
        if (photo.hasOwnProperty('galleryPath')) {
          let payload = {
            uid: this.uid,
            eid: photo.eid,
            pid: photo.pid,
            galleryPath: photo.galleryPath
          }
          this.$store.dispatch('photo/addGalleryPathToPhoto', payload)
        }
      })
    })
  }
}
</script>

<style scoped>
.blue-stripe {
  border-left: 4px solid #007bff;
}
.container {
}
div.statement {
  white-space: pre-line;
  white-space: pre-wrap;
  padding-top: 1em;
}

.alert-warning {
  position: relative;
  background: #ffeeba;
  border: 1px solid #ffeeba;
}
.alert-warning:after,
.alert-warning:before {
  top: 100%;
  left: 50%;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.alert-warning:after {
  border-color: rgba(255, 238, 186, 0);
  border-top-color: #ffeeba;
  border-width: 15px;
  margin-left: -15px;
}
.alert-warning:before {
  border-color: rgba(255, 238, 186, 0);
  border-top-color: #ffeeba;
  border-width: 16px;
  margin-left: -16px;
}
@media (min-width: 768px) {
  .alert-warning:after,
  .alert-warning:before {
    left: 5%;
  }
}

#drag-and-drop {
  background-color: white;
  height: 200px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
#preview-wrapper {
  width: 1px;
  height: 1px;
  overflow: hidden;
}
.gallery-story {
  padding-top: 2em;
}
</style>
